module.exports = __webpack_public_path__ + "images/icons/icon-payment-sofort-c2386a46.svg";